import { Component, OnInit } from "@angular/core";
import { AuthService } from "./auth.service";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit {
  public backgroundImage: string;
  constructor(public _authService: AuthService) {
    this.backgroundImage = "assets/img/fondo-auth.jpeg";
  }

  ngOnInit(): void {}

  manageAction(e) {
    if (e == "closing") this._authService.showAuth = true;
  }
}
